/*
 * !!! vendor, править нельзя !!!
 * Скопипащенный HOC из репы виджета: https://git.skbkontur.ru/platform/widgets/addresses.widget/-/blob/master/npm-loader/react.tsx
 * Скопипащен, т.к. была проблема с несоответствием версий React (у нас 17, в виджете 18)
 * Виджеты обещали вскоре выкатить новую версию с шарингом через esm.sh, там должно полечиться
 * */

import React, { type ForwardedRef, type ComponentType, forwardRef, useEffect, useRef, type ReactNode } from "react";
// @ts-ignore надо обновить moduleResolution до nodenext
import { EventBusConstructor, FiasFullValue, ValueChangeOptions } from "@skbkontur/fias-widget-npm-loader";

interface HOCProps {
    onValueChange: (v: FiasFullValue) => void;
    onUnexpectedInput?: (query: string) => void | null | FiasFullValue;
    onBlur?: () => void;
    onInputValueChange?: () => unknown;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WithValidationTransport = <TProps extends Record<string, any>>(
    Comp: ComponentType<TProps & { eventBus: EventBusConstructor }>
): ComponentType<Omit<TProps, "eventBus"> & HOCProps> => {
    const ResultComponent = (
        props: TProps & HOCProps & { error: boolean; warning: boolean },
        ref: ForwardedRef<HTMLDivElement>
    ): ReactNode => {
        const eventBus = useRef(new EventBusConstructor());
        useEffect(() => {
            const payload = {
                error: props.error,
                warning: props.warning,
            };
            setTimeout(() => {
                eventBus.current?.publish({ type: "ValidationChanged", payload: payload });
            }, 0);
        }, [props.error, props.warning]);
        useEffect(() => {
            const handleValueChange = (v: FiasFullValue, _options: ValueChangeOptions) => {
                setTimeout(() => {
                    props.onBlur?.(); // для работы валидации при сохранении
                }, 0);
                props.onValueChange?.(v);
            };
            const handleUnexpectedInput = (q: string) => {
                props.onUnexpectedInput?.(q);
                setTimeout(() => {
                    props.onBlur?.(); // для работы валидации при потере фокуса
                }, 0);
            };
            const { unsubscribe: unsubscribeBlur } = eventBus.current.subscribe({
                type: "Blur",
                callback: () => props.onBlur?.(),
            });
            const { unsubscribe: unsubscribeValueChange } = eventBus.current.subscribe({
                type: "ValueChanged",
                callback: handleValueChange,
            });
            const { unsubscribe: unsubscribeInputValueChange } = eventBus.current.subscribe({
                type: "InputValueChanged",
                callback: () => props.onInputValueChange?.(),
            });
            const { unsubscribe: unsubscribeUnexpectedInput } = eventBus.current.subscribe({
                type: "UnexpectedInput",
                callback: handleUnexpectedInput,
            });
            return () => {
                unsubscribeBlur();
                unsubscribeValueChange();
                unsubscribeInputValueChange();
                unsubscribeUnexpectedInput();
            };
        }, [props.onInputValueChange, props.onBlur, props.onValueChange, props.onUnexpectedInput]);

        const innerRef = useRef<HTMLDivElement | null>(null);

        return (
            <div
                ref={element => {
                    innerRef.current = element;
                    if (element) {
                        element.focus = (...params: unknown[]) => {
                            eventBus.current.publish({ type: "Focus", payload: params });
                        };
                    }
                    if (typeof ref === "function") {
                        ref(element);
                    } else if (ref) {
                        ref.current = element;
                    }
                }}
                style={{ display: "inline-block" }}>
                <Comp {...props} eventBus={eventBus.current} />
            </div>
        );
    };
    ResultComponent.__KONTUR_REACT_UI__ = "ComboBox";
    // @ts-ignore
    return forwardRef<HTMLDivElement, Omit<TProps, "eventBus"> & HOCProps>(ResultComponent);
};
